var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 16l-2.943-3.268.46-4.375-4.303-.91-2.195-3.815L16 5.428 15.458 16 16 26.572l4.019 1.796 2.195-3.814 4.304-.911-.461-4.375L29 16z",
    fill: "#1847DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.982 3.632L9.786 7.446l-4.304.911.461 4.375L3 16l2.943 3.268-.46 4.375 4.303.91 2.196 3.815L16 26.572V5.428l-4.018-1.796z",
    fill: "#0045FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.45 13.153l-1.139-1.015L16 16.968l-.542 1.201.542 1.09 5.45-6.106z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.468 14.851L10.39 15.93l4.534 4.534L16 19.26v-2.29l-1.139 1.275-3.393-3.393z",
    fill: "#fff"
  })));
}
export default SvgCheck;